import qs from "qs";
import * as axiosHelper from "./api_helper";

export const getBlockedIps = async({ payload }) => {
  const data = await axiosHelper.get(`/ipAccessControl?${qs.stringify(payload)}`);
  return data.result;
};

export const addBlock = async({ payload }) => {
  const data = await axiosHelper.post("/ipAccessControl", payload);
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

export const deleteBlock = async({ payload }) => {
  const data = await axiosHelper.del(`/ipAccessControl/${payload}`);
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};
